module.exports = __webpack_public_path__ + "static/media/ispe.c83ba538.png";